'use strict';

/** 
* Базовый объект страницы.
*
* @class WebAccess.components.wrappers.BasePageElement
* @extends AbstractBasePageElement
* @property {string} className Имя класса
* @property {string} name Имя объекта
* @property {string} selector Селектор для работы с объектом вне API
*/

(function (global) {

  /**
   * Класс jQuery-элемента на странице.
   *
   * @abstract
   * @extends WebAccess.components.wrappers.AbstractBasePageElement
   */
  var BasePageElement = WebAccess.components.wrappers.AbstractBasePageElement.extend({

    /**
     * Конструктор.
     *
     * @param {string} itemSelector Селектор существующего элемента страницы
     * @method WebAccess.components.wrappers.BasePageElement#init
     * @override
     * @see WebAccess.components.wrappers.AbstractBasePageElement#init
     */
    init: function (itemSelector) {
      this._super(itemSelector);
      this._jObject = $(itemSelector);
      this.name = this._jObject.attr('name');
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Имя класса.
     *
     * @private
     * @property WebAccess.components.wrappers.BasePageElement#className
     * @override
     * @see WebAccess.components.wrappers.AbstractBasePageElement#className
     */
    className: 'BasePageElement',

    /**
     * Имя элемента страницы.
     *
     * @private
     * @property BasePageElement#name
     */
    name: '',

    /**
     * jQuery-объект элемента страницы.
     *
     * @private
     * @property BasePageElement#_jObject
     */
    _jObject: {},

    /**
     * События, связанные с текущих элементом страницы.
     *
     * @private
     * @property BasePageElement#_storedEvents
     */
    _storedEvents: [],


    /**
     * jQuery-селектор элемента страницы с использованием имени элемента.
     *
     * @private
     * @property BasePageElement#_byNameSelectorTemplate
     */
    _byNameSelectorTemplate: '{0}[name={1}]',
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Признак скрытия элемента страницы.
     *
     * @method WebAccess.components.wrappers.BasePageElement#isHidden
     * @return {boolean} True, если элемент скрыт, иначе False.
     * @override
     * @see WebAccess.components.wrappers.AbstractBasePageElement#isHidden
     */
    isHidden: function () {
      return !this._jObject.is(':visible');
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Признак отображения элемента страницы.
     *
     * @method WebAccess.components.wrappers.BasePageElement#isEnabled
     * @return {boolean} True, если элемент отображается, иначе False.
     * @override
     * @see WebAccess.components.wrappers.AbstractBasePageElement#isEnabled
     */
    isEnabled: function () {
      return !this._jObject.hasClass('disabled');
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Признак выбора элемента страницы.
     *
     * @method WebAccess.components.wrappers.BasePageElement#isSelected
     * @return {boolean} True, если элемент выбран, иначе False.
     * @override
     * @see WebAccess.components.wrappers.AbstractBasePageElement#isSelected
     */
    isSelected: function () {
      return this._jObject.hasClass('selected');
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Отображает элемент страницы.
     * 
     * @method WebAccess.components.wrappers.BasePageElement#show
     * @return {WebAccess.components.wrappers.BasePageElement} Объект типа BasePageElement.
     * @fires BasePageElement#show
     * @override
     * @see WebAccess.components.wrappers.AbstractBasePageElement#show
     */
    show: function () {
      this._jObject.show();
      this.fire(WebAccess.components.wrappers.AbstractBasePageElement.EVENT.SHOW);
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Скрывает элемент страницы.
     *
     * @method WebAccess.components.wrappers.BasePageElement#hide
     * @return {WebAccess.components.wrappers.BasePageElement} Объект типа BasePageElement.
     * @fires BasePageElement#hide
     * @override
     * @see WebAccess.components.wrappers.AbstractBasePageElement#hide
     */
    hide: function () {
      this._jObject.hide();
      this.fire(WebAccess.components.wrappers.AbstractBasePageElement.EVENT.HIDE);
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Устанавливает заголовок элемента страницы.
     *
     * @method WebAccess.components.wrappers.BasePageElement#setLabel
     * @param {string} text Заголовок элемента страницы.
     * @return {WebAccess.components.wrappers.BasePageElement} Объект типа BasePageElement.
     * @fires BasePageElement#change
     * @override
     * @see WebAccess.components.wrappers.AbstractBasePageElement#setLabel
     */
    setLabel: function (text) {
      this._jObject.find('span').text(text);
      this.fire(WebAccess.components.wrappers.AbstractBasePageElement.EVENT.CHANGE);
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Получает заголовок элемента страницы.
     *
     * @method WebAccess.components.wrappers.BasePageElement#getLabel
     * @return {string} Заголовок элемента страницы.
     * @override
     * @see WebAccess.components.wrappers.AbstractBasePageElement#getLabel
     */
    getLabel: function () {
      return this._jObject.find('span').text();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


    /**
     * Устанавливает всплывающую подсказку.
     *
     * @fires BasePageElement#change
     * @method WebAccess.components.wrappers.BasePageElement#setTooltip
     * @override
     * @param {string} tooltip Текст всплывающей подсказки.
     * @return {WebAccess.components.wrappers.BasePageElement} Объект типа BasePageElement.
     * @see WebAccess.components.wrappers.AbstractBasePageElement#setTooltip
     */
    setTooltip(tooltip) {
      let label = this.getLabel();
      // Добавим название кнопки в подсказку к этой кнопке.
      if (tooltip !== label) {
        tooltip = `${label}\n${tooltip}`;
      }
      this._jObject.attr('title', tooltip);
      this.fire(WebAccess.components.wrappers.AbstractBasePageElement.EVENT.CHANGE);
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Получает текст всплывающей подсказки.
     *
     * @method WebAccess.components.wrappers.BasePageElement#getTooltip
     * @return {string} Текст всплывающей подсказки.
     * @override
     * @see WebAccess.components.wrappers.AbstractBasePageElement#getTooltip
     */
    getTooltip: function () {
      return this._jObject.attr('title');
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Устанавливает иконку.
     *
     * @method WebAccess.components.wrappers.BasePageElement#setIcon
     * @param {string} path Путь к иконке.
     * @return {WebAccess.components.wrappers.BasePageElement} Объект типа BasePageElement.
     * @fires BasePageElement#change
     * @override
     * @see WebAccess.components.wrappers.AbstractBasePageElement#setIcon
     */
    setIcon: function (path) {

      if (path.indexOf('.') !== -1) {

        var jSvgIcon = this._jObject.find('svg');

        if (jSvgIcon.length != 0) {
          jSvgIcon.remove();
          var jContainer = this._jObject.find('div').first();
          jContainer.prepend('<p></p>');
        }

        if (path.indexOf('/App_Sprites/') !== -1) {
          path = path.substring(path.indexOf('s/') + 2);
        }

        this._jObject.find('p').first().removeClass().addClass(path);
      }
      else {
        var jSpriteIcon = this._jObject.find('p').first();
        if (jSpriteIcon.length !== 0) {
          var jContainer = this._jObject.find('div').first();
          jSpriteIcon.remove();
          jContainer.prepend('<svg class="svg-component"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#' + path + '"></use></svg>');
        }
        else {
          var jUseElement = this._jObject.find('use').first();
          jUseElement.attr('xlink:href', '#' + path);
        }
      }

      this.fire(WebAccess.components.wrappers.AbstractBasePageElement.EVENT.CHANGE);
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Получает имя иконки.
     *    
     * @method WebAccess.components.wrappers.BasePageElement#getIcon
     * @return {string} Имя иконки.
     * @override
     * @see WebAccess.components.wrappers.AbstractBasePageElement#getIcon
     */
    getIcon: function () {

      var jSvgIcon = this._jObject.find('svg');

      if (jSvgIcon.length !== 0)
        return jSvgIcon.children('use').attr('xlink:href').substr(1);

      return this._jObject.find('p').first().attr('class');
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Имитирует щелчок мыши на кнопке или устанавливает обработчик на событие onClick, если передан параметр opt_callback.
     *
     * @method WebAccess.components.wrappers.BasePageElement#click
     * @param {function} [opt_callback] Функция, которая будет вызвана после щелчка мыши по кнопке.
     * @return {WebAccess.components.wrappers.BasePageElement} Объект типа BasePageElement.
     * @override
     * @see WebAccess.components.wrappers.AbstractBasePageElement#click
     */
    click: function (opt_callback) {
      var instance = this;
      if ($.isFunction(opt_callback)) {
        instance._disableClickHandler(instance._jObject);
        instance
          .unbind(BaseObject.EVENT.CLICK)
          .bind(BaseObject.EVENT.CLICK, opt_callback);
      } else {
        instance._jObject.click();
      }
      return instance;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Получает действие по умолчанию.
     *
     * @private
     * @method WebAccess.components.wrappers.BasePageElement#_defaultAction
     * @return {function} Действие по умолчанию.
     */
    _defaultAction: function () {
      if (!this._inlineEvent) return;
      return (new Function(this._inlineEvent)).call(this._jObject.get(0));
    },

    /**
     * Вызов нашего fire при клике на элемент.
     *
     * @private
     * @method WebAccess.components.wrappers.BasePageElement#_eventHandler
     */
    _eventHandler: function (event) {
      var eventName = event.data.eventName;
      var name = event.data.buttonName;
      var element = event.data.instance;
      var continueDefaultAction = event.data.continueDefaultAction;

      if (element.fire(eventName, name, continueDefaultAction) !== false && eventName === 'click') {
        element._defaultAction.call(element);
      }
    },

    /**
     * Привязывает функцию к событию.
     *
     * @method WebAccess.components.wrappers.BasePageElement#bind
     * @param {string} name Имя события.
     * @param {function} callback Функция, срабатывающая при событии.
     * @return {WebAccess.components.wrappers.BasePageElement} Объект типа BasePageElement.
     * @override
     * @see WebAccess.components.wrappers.BaseObject#bind
     */
    bind: function (event, callback) {
      var instance = this;
      if (event === 'click') {
        this._storeInlineEvents();
      }

      this._super(event, callback);
      //if (event == "click") this._disableClickHandler(this._jObject);    
      this._jObject.unbind(event, this._eventHanler).bind(event, {
        'instance': instance,
        'eventName': event,
        'buttonName': instance.name,
        'continueDefaultAction': $.proxy(instance._defaultAction, instance)
      }, this._eventHandler);
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


    /**
     * Отключение обработчика click у объекта.
     *
     * @private
     * @method WebAccess.components.wrappers.BasePageElement#_disableClickHandler
     * @param {object} jObject - jQuery-обеъект, у которого отключается обработчик.
     */
    _disableClickHandler: function (jObject) {

      jObject.removeAttr('onclick'); // Здесь именно так 
      jObject.prop('onclick', null); // именно две строки

      jObject.off('click');
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Делает элемент страницы недоступным.
     *
     * @method WebAccess.components.wrappers.BasePageElement#disable
     * @return {WebAccess.components.wrappers.BasePageElement} Объект типа BasePageElement.
     * @fires BasePageElement#disable
     * @override
     * @see WebAccess.components.wrappers.AbstractBasePageElement#disable
     */
    disable: function () {
      if (this.isEnabled()) { // Без этого если вызывать disable 2 раза, то он потеряет события вообще.
        this._storeEvents();
        this._jObject.unbind('click');
        this._jObject.addClass('disabled').removeClass('hover');
        this.fire(WebAccess.components.wrappers.AbstractBasePageElement.EVENT.DISABLE);
      }
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Делает элемент страницы доступным.
     *
     * @method WebAccess.components.wrappers.BasePageElement#enable
     * @return {WebAccess.components.wrappers.BasePageElement} Объект типа BasePageElement.
     * @fires BasePageElement#enable
     * @override
     * @see WebAccess.components.wrappers.AbstractBasePageElement#enable
     */
    enable: function () {
      if (!this.isEnabled()) {
        this._jObject.removeClass('disabled');
        this._restoreEvents();
        this.fire(WebAccess.components.wrappers.AbstractBasePageElement.EVENT.ENABLE);
      }
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Сохранение привязанных обработчиков событий
     *
     * @method WebAccess.components.wrappers.BasePageElement#_storeEvents
     * @return {WebAccess.components.wrappers.BasePageElement} Объект типа BasePageElement.
     */
    _storeEvents: function () {
      this._storeInlineEvents();
      this._storedEvents = this._events;

      this._events = [];
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Сохранение того, что было навешено на атрибут onclick.
     * @private
     * @method WebAccess.components.wrappers.BasePageElement#_storeInlineEvents
     */
    _storeInlineEvents: function () {
      if (this._jObject.hasAttr('onclick')) {
        if (WA.ENV.browser.name !== 'IE' && WA.ENV.browser.major !== '7') {
          this._inlineEvent = this._jObject.attr('onclick'); //Здесь имеенно attr, не prop! и точка.
          this._jObject.removeAttr('onclick'); // Аналогично
        }
        //this._jObject.prop("onclick")
      }
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Восстановление привязанных обработчиков событий
     *
     * @private
     * @method WebAccess.components.wrappers.BasePageElement#_storeEvents
     * @return {WebAccess.components.wrappers.BasePageElement} Объект типа BasePageElement.
     */
    _restoreEvents: function () {
      this._restoreInlineEvents();
      if (Object.keys(this._storedEvents).length > 0) {
        this._events = this._storedEvents;
        this._storedEvents = [];

        var instance = this;
        for (var event in this._events) {
          if (this._events.hasOwnProperty(event)) {
            this._jObject.bind(event, function () {
              instance.fire(event, instance.name);
            });
          }
        }
      }

      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Восстановление привязанных атрибутом обработчиков событий onclick
     *
     * @private
     * @method WebAccess.components.wrappers.BasePageElement#_restoreInlineEvents
     */
    _restoreInlineEvents: function () {
      if (this._inlineEvent !== '') {
        this._jObject.attr('onclick', this._inlineEvent);
      } //И здесь имеенно attr, не prop! железно!
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Отображает кнопку как нажатую.
     *
     * @method WebAccess.components.wrappers.BasePageElement#select
     * @return {WebAccess.components.wrappers.BasePageElement} Объект типа BasePageElement.
     * @override
     * @see WebAccess.components.wrappers.AbstractBasePageElement#select
     */
    select: function () {
      this._jObject.addClass('selected');
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Отображает кнопку как ненажатую.
     *
     * @method WebAccess.components.wrappers.BasePageElement#unSelect
     * @return {WebAccess.components.wrappers.BasePageElement} Объект типа BasePageElement.
     * @override
     * @see WebAccess.components.wrappers.AbstractBasePageElement#unSelect
     */
    unSelect: function () {
      this._jObject.removeClass('selected');
      return this;
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  });

  global.BasePageElement = BasePageElement;

})(window.WebAccess.components.wrappers);
